import {Injectable} from '@angular/core';
import {UserResultPref, UserResultPrefValueType} from '@sharedcommon/model/user.result-pref.model';
import {TranslateService} from '@ngx-translate/core';
import {RawMaterialDto} from '@sharedrest/data.restservice';
import {Constants} from '@sharedcommon/util/constants.util';
import {FunctionUtils} from '@sharedcommon/util/functions.util';
import {UserService} from '@sharedcommon/services/user.service';
import {MatrixDto} from '@sharedrest/equation.restservice';
import { SampleDto } from '@sharedcommon/model/sample/sample.model';

@Injectable()
export class ResultSettingsService {

  private resultPrefs: UserResultPref[];
  private labelCurrent: string;

  constructor(private readonly translate: TranslateService, private readonly userService: UserService) {
  }


  public clear() {
    this.resultPrefs = undefined;
  }


  public createDefaultRawMaterialOrSample(): RawMaterialDto|SampleDto {
    if (FunctionUtils.isNotDefined(this.labelCurrent)) {
      this.labelCurrent = this.translate.instant(Constants.USER_RESULT_CURRENT_RAWMATERIAL_LABEL);
    }
    return {
      id: Constants.USER_RESULT_CURRENT_RAWMATERIAL_ID,
      label: this.labelCurrent,
      code: this.labelCurrent,
      referenceId: null
    };
  }

  private createDefaultResultPrefs(): UserResultPref[] {
    return [
      {
        id: 1,
        matrix: this.userService.getMainMatrix(),
        rawMaterialOrSample: this.createRawMaterialOrSampleDatasource(this.createDefaultRawMaterialOrSample()),
        valueType: UserResultPrefValueType.CALCULATED
      },
      {
        id: 2,
        matrix: this.userService.getMainMatrix(),
        rawMaterialOrSample: this.createRawMaterialOrSampleDatasource(this.createDefaultRawMaterialOrSample()),
        valueType: UserResultPrefValueType.SAVED
      },
      {
        id: 3,
        matrix: this.userService.getMainMatrix(),
        rawMaterialOrSample: this.createRawMaterialOrSampleDatasource(this.createDefaultRawMaterialOrSample()),
        valueType: UserResultPrefValueType.STANDARD
      }
    ];
  }

  public createRawMaterialOrSampleDatasource(rawMaterial: RawMaterialDto|SampleDto): any {
    let label: string;
    if (rawMaterial.id === Constants.USER_RESULT_CURRENT_RAWMATERIAL_ID) {
      label = rawMaterial.label;
    } else {
      label = `${rawMaterial.code} - ${rawMaterial.label}`;
    }

    return Object.assign(rawMaterial, {customLabel: label});
  }

  public createMatrixDatasource(matrix: MatrixDto): any {
    const label = `${matrix.code} - ${matrix.label}`;
    return Object.assign(matrix, {customLabel: label});
  }

  public newDefaultResultPref(): UserResultPref {
    return {
      id: null,
      matrix: this.userService.getMainMatrix(),
      rawMaterialOrSample: this.createRawMaterialOrSampleDatasource(this.createDefaultRawMaterialOrSample()),
      valueType: UserResultPrefValueType.CALCULATED
    };
  }

  public getResultPrefs(): UserResultPref[] {
    if (FunctionUtils.isNotDefined(this.resultPrefs)) {
      this.resultPrefs = this.createDefaultResultPrefs();
    }
    return this.resultPrefs;
  }

  setResultPrefs(newResultPref: UserResultPref[]) {
    this.resultPrefs = newResultPref;
  }
}
